import { useState } from 'react';
import { ADMIN_ENDPOINTS, adminFetch } from '../config';
import './Admin.css';

export default function AdminPassword() {
  const [current, setCurrent] = useState('');
  const [newPass, setNewPass] = useState('');
  const [confirm, setConfirm] = useState('');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    if (newPass.length < 8) {
      setMessage('New password must be at least 8 characters.');
      return;
    }
    if (newPass !== confirm) {
      setMessage('New passwords do not match.');
      return;
    }
    setSubmitting(true);
    try {
      const res = await adminFetch(ADMIN_ENDPOINTS.changePassword, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ current, new: newPass, confirm }),
      });
      const data = await res.json();
      if (data.error) setMessage(data.error);
      else {
        setMessage('Password updated successfully.');
        setCurrent('');
        setNewPass('');
        setConfirm('');
      }
    } catch {
      setMessage('Failed to update.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <h1>Change Password</h1>
      {message && <p style={{ color: message.includes('success') ? '#3fb950' : 'var(--admin-danger)' }}>{message}</p>}
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Current password</label>
          <input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} required />
        </div>
        <div className="form-group">
          <label>New password</label>
          <input type="password" value={newPass} onChange={(e) => setNewPass(e.target.value)} required minLength={8} />
        </div>
        <div className="form-group">
          <label>Confirm new password</label>
          <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={8} />
        </div>
        <button type="submit" className="btn" disabled={submitting}>{submitting ? 'Updating…' : 'Update'}</button>
      </form>
    </>
  );
}
